import { FC } from "react";
import { Button } from "@twilio-paste/button";
import { Box } from "@twilio-paste/box";
import { MicrophoneOffIcon } from "@twilio-paste/icons/esm/MicrophoneOffIcon";
import { MicrophoneOnIcon } from "@twilio-paste/icons/esm/MicrophoneOnIcon";
import { useLocalAudioToggle } from "../../../hooks/useLocalAudioToggle/useLocalAudioToggle";
import { useVideoContext } from "../../../hooks/useVideoContext/useVideoContext";
import { ButtonProps } from "../../../types";

export const ToggleAudioButton: FC<ButtonProps> = (props: ButtonProps) => {
	const [isAudioEnabled, toggleAudioEnabled] = useLocalAudioToggle();
	const { localTracks } = useVideoContext();
	const hasAudioTrack = localTracks.some(track => track.kind === "audio");

	return (
		<Button
			variant={props.menuButton ? "reset" : "secondary"}
			onClick={toggleAudioEnabled}
			disabled={!hasAudioTrack || props.disabled}
			data-cy-audio-toggle
			fullWidth
		><Box display="flex" alignItems="center" columnGap="space30">
				{isAudioEnabled ? <MicrophoneOnIcon decorative={true}/> : <MicrophoneOffIcon decorative={true} />} {!hasAudioTrack ? "No Audio" : isAudioEnabled ? "Mute" : "Unmute"}
			</Box>
		</Button>
	);
}
